// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyText_container___8gOv","textContainer":"CopyText_textContainer__3SoFF","icon":"CopyText_icon___E18f","text":"CopyText_text__276k0"};